import React from 'react';
import classNames from 'classnames';
import { string, node, oneOf, number } from 'prop-types';
import { POSITIONS } from '../constants';
import styles from './index.module.scss';

const getCornerOffsetStyles = (offset) => ({
    [POSITIONS.BOTTOM_RIGHT]: { bottom: offset, right: offset },
    [POSITIONS.BOTTOM_LEFT]: { bottom: offset, left: offset },
    [POSITIONS.TOP_LEFT]: { top: offset, left: offset },
    [POSITIONS.TOP_RIGHT]: { top: offset, right: offset }
});

const getCornerOffset = ({
    avatarSize,
    cornerSize,
    borderSize = 0
}) => {
    const defaultOffset = 0;

    if (!cornerSize || !avatarSize) {
        return defaultOffset;
    }

    const radius = avatarSize / 2;
    const indicatorCenter = radius * Math.cos((45 * Math.PI) / 180) + radius;
    const offset =
        avatarSize - indicatorCenter - cornerSize / 2 - borderSize;

    return Math.floor(offset);
};

const Corner = ({
    avatarSize,
    cornerSize,
    borderSize,
    className,
    children,
    position
}) => {
    const cornerOffset = getCornerOffset({
        avatarSize,
        cornerSize,
        borderSize
    });

    const cornerStyles = getCornerOffsetStyles(cornerOffset);

    return (
        <div className={classNames(className, styles.corner)}
            style={{ ...cornerStyles[position] }}>
            {children}
        </div>
    );
};

Object.assign(Corner, {
    POSITIONS
});

Corner.propTypes = {
    className: string,
    children: node.isRequired,
    position: oneOf(Object.values(POSITIONS)),
    avatarSize: number,
    cornerSize: number,
    borderSize: number
};

Corner.defaultProps = {
    position: POSITIONS.BOTTOM_RIGHT,
    children: null
};

export default Corner;
